export const SETTINGS_ROOT = '/settings'
export const WALKIN_APP = '/settings/walk-in'

export const BILLING_SETTINGS = '/settings/billing'
export const ACCOUNT_SETTINGS = '/settings/account'
export const COMPANY_SETTINGS = '/settings/company'